import { render, staticRenderFns } from "./BindNew.vue?vue&type=template&id=ca32e9b2&scoped=true&"
import script from "./BindNew.vue?vue&type=script&lang=js&"
export * from "./BindNew.vue?vue&type=script&lang=js&"
import style0 from "./BindNew.vue?vue&type=style&index=0&id=ca32e9b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca32e9b2",
  null
  
)

export default component.exports